import { render, staticRenderFns } from "./select.vue?vue&type=template&id=5bd6c866"
import script from "./select.vue?vue&type=script&lang=js"
export * from "./select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/whitewe_jisheng-mes-ui_CPvN/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bd6c866')) {
      api.createRecord('5bd6c866', component.options)
    } else {
      api.reload('5bd6c866', component.options)
    }
    module.hot.accept("./select.vue?vue&type=template&id=5bd6c866", function () {
      api.rerender('5bd6c866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/select/select.vue"
export default component.exports